<template>
<div>
  <movements-page-primary-market v-if="!InvestorRegisteredOnSecondaryMarket"/>
  <movements-page-secondary-market v-else/>
</div>
</template>

<script>

import MovementsPagePrimaryMarket from '@views/investor/investments/MovementsPagePrimaryMarket';
import MovementsPageSecondaryMarket from '@views/investor/investments/MovementsPageSecondaryMarket';
export default {
   components: { MovementsPagePrimaryMarket, MovementsPageSecondaryMarket },
   data(){
      return {
        
      }
   }
}
</script>